export default {
  validate: {
    username: '请输入用户名',
    password: '请输入密码',
    notEmpty: '所填项不得为空',
    isMobile: '请输入手机号码',
    isIP: '请输入正确的IP地址',
    isAmount: '请输入正确的格式(数字、小数点后最多保留两位)',
    isMail: '请输入正确的邮箱格式',
    passwordReg: '请输入正确的格式(8-20位数字、大小写字母、半角符号组合)'
  }
}
